// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file unacast/boundaries/typesetpb/v1/typeset.proto (package unacast.boundaries.typesetpb.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum unacast.boundaries.typesetpb.v1.TypesetGroup
 */
export enum TypesetGroup {
  /**
   * @generated from enum value: TYPESET_GROUP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TYPESET_GROUP_BRANDS = 1;
   */
  BRANDS = 1,

  /**
   * @generated from enum value: TYPESET_GROUP_CATEGORIES = 2;
   */
  CATEGORIES = 2,

  /**
   * @generated from enum value: TYPESET_GROUP_POSTAL_CODES = 3;
   */
  POSTAL_CODES = 3,

  /**
   * @generated from enum value: TYPESET_GROUP_ADMIN_LEVELS = 4;
   */
  ADMIN_LEVELS = 4,

  /**
   * @generated from enum value: TYPESET_GROUP_CITIES = 5;
   */
  CITIES = 5,

  /**
   * @generated from enum value: TYPESET_GROUP_COUNTRIES = 6;
   */
  COUNTRIES = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(TypesetGroup)
proto3.util.setEnumType(TypesetGroup, "unacast.boundaries.typesetpb.v1.TypesetGroup", [
  { no: 0, name: "TYPESET_GROUP_UNSPECIFIED" },
  { no: 1, name: "TYPESET_GROUP_BRANDS" },
  { no: 2, name: "TYPESET_GROUP_CATEGORIES" },
  { no: 3, name: "TYPESET_GROUP_POSTAL_CODES" },
  { no: 4, name: "TYPESET_GROUP_ADMIN_LEVELS" },
  { no: 5, name: "TYPESET_GROUP_CITIES" },
  { no: 6, name: "TYPESET_GROUP_COUNTRIES" },
]);

/**
 * @generated from message unacast.boundaries.typesetpb.v1.MetadataType
 */
export class MetadataType extends Message<MetadataType> {
  /**
   * @generated from field: string typeset_name = 1;
   */
  typesetName = "";

  /**
   * @generated from field: string type_key = 2;
   */
  typeKey = "";

  /**
   * @generated from field: string display_name = 3;
   */
  displayName = "";

  /**
   * @generated from field: optional string short_name = 4;
   */
  shortName?: string;

  /**
   * @generated from field: bool validated = 10;
   */
  validated = false;

  constructor(data?: PartialMessage<MetadataType>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.typesetpb.v1.MetadataType";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "typeset_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "short_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "validated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MetadataType {
    return new MetadataType().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MetadataType {
    return new MetadataType().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MetadataType {
    return new MetadataType().fromJsonString(jsonString, options);
  }

  static equals(a: MetadataType | PlainMessage<MetadataType> | undefined, b: MetadataType | PlainMessage<MetadataType> | undefined): boolean {
    return proto3.util.equals(MetadataType, a, b);
  }
}

